import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { TabChip } from "@/components";
import { classNames } from "@/utils/classNames";

import { ReplyTab } from "./inboxReplyTabs";

export interface InboxReplyCounts {
	myReplies?: number;
	teamReplies?: number;
	allReplies?: number;
}

interface InboxReplyTabStripProps {
	activeTab: ReplyTab;
	counts?: InboxReplyCounts;
	onChange: (tab: ReplyTab) => void;
}

/** The My/Team/All replies tab strip shown above the Inbox filter bar. */
export const InboxReplyTabStrip: FunctionComponent<InboxReplyTabStripProps> = ({
	activeTab,
	counts,
	onChange,
}) => {
	const { t } = useTranslation();

	const tabs = [
		{ value: ReplyTab.MY, label: t("inbox.replyTabs.my"), count: counts?.myReplies },
		{ value: ReplyTab.TEAM, label: t("inbox.replyTabs.team"), count: counts?.teamReplies },
		{ value: ReplyTab.ALL, label: t("inbox.replyTabs.all"), count: counts?.allReplies },
	];

	return (
		<div className="flex bg-white border-b border-border-light w-full flex-shrink-0">
			{tabs.map((tab) => {
				const isActive = activeTab === tab.value;

				return (
					<button
						key={tab.value}
						className={classNames(
							"flex items-center gap-1.5 px-4 py-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap cursor-pointer",
							isActive
								? "border-brand-light text-brand-light"
								: "border-transparent text-text-meta hover:text-text hover:border-gray-300"
						)}
						type="button"
						onClick={() => onChange(tab.value)}
					>
						<span>{tab.label}</span>
						{typeof tab.count === "number" && <TabChip active={isActive} label={`${tab.count}`} />}
					</button>
				);
			})}
		</div>
	);
};
